import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaBullhorn,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const PromotionalVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Promotional Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Brand</Subheading>}
        heading={
          <Heading>
            Promotional <span tw="text-primary-500">Video Production</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in promotional video production in **Bur
            Dubai**, creating dynamic, engaging videos that capture attention
            and drive your brand’s message to boost sales and visibility.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1601506521941-ca8a9ea2f0db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Creative video production
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Dynamic video content
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Campaign"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Dynamic Promotional Videos in Bur Dubai"
        description="We craft promotional videos that captivate and convert."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Attention-Grabbing Content",
            description: "Videos designed to hook your audience instantly.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Production",
            description: "Stunning visuals to elevate your brand.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround for timely campaigns.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Social Media Optimized",
            description:
              "Videos tailored for platforms like Instagram and YouTube.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Brands",
            description: "Bur Dubai’s choice for promotional videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Campaigns",
            description: "Tailored videos for products, services, or events.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Promotional Video Process"
        description={
          <Description>
            We create impactful promotional videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your campaign goals and audience.</li>
              <li>
                Storyboarding: Craft a compelling, action-driven narrative.
              </li>
              <li>
                Filming: Capture vibrant visuals with professional equipment.
              </li>
              <li>Editing: Enhance with effects, music, and branding.</li>
              <li>Delivery: Provide ready-to-share promotional videos.</li>
              <li>Support: Offer ongoing tweaks and campaign support.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Storyboarding session
          "https://images.unsplash.com/photo-1603729340594-9e0c31e0063b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Camera equipment closeup
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Video editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Promotional Video Wins in Bur Dubai"
        description="Our promotional videos have driven results for businesses."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Viral Campaigns",
            description: "Increased engagement with dynamic ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Success",
            description: "92% satisfaction from Bur Dubai brands.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Improved conversions with targeted videos.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Promote Your Brand?</Subheading>}
        heading="Promotional Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert promotional video production
            in Bur Dubai. Get vibrant, high-impact videos to skyrocket your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1583217874484-9e3a5ee3dd5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai cityscape/skyline
          "https://images.unsplash.com/photo-1524649466382-c1c6b5b6e9cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80", // Creative marketing team
          "https://images.unsplash.com/photo-1551218372-a8dadaee604a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
